export default __webpack_public_path__ + "static/07_Horse-29a09f56e7acd44815e4f9ceccf507d5.png";